import defaultAttributes from '../defaultAttributes';

const Mountain = [
  'svg',
  defaultAttributes,
  [['path', { d: 'm8 3 4 8 5-5 5 15H2L8 3z' }]],
];

export default Mountain;
